'use strict';

const _ = require('underscore');
const Backbone = require('backbone');
const TaskRepository = require('communication/domain/repository/task');
const TaskInCommentCollection = require('communication/domain/collection/task-in-comment');
const TaskCollection = require('communication/domain/collection/task');

class TaskCollectionRepository {
    constructor(project) {
        this._project = project;
        this._repo = TaskRepository.find(project);
        this._tasksByKey = {};
        this._tasksByComment = {};
    }

    byComment(comment) {
        let tasks = this._tasksByComment[comment.key];
        if(!tasks) {
            tasks = new TaskInCommentCollection([], {
                comment: comment,
                repository: this._repo
            });
            this._tasksByComment[comment.key] = tasks;
        }

        return tasks;
    }

    byKey(key) {
        let tasks = this._tasksByKey[key];
        if(!tasks) {
            tasks = new TaskCollection([], {
                key: key,
                repository: this._repo
            });
            this._tasksByKey[key] = tasks;
        }

        return tasks;
    }
}

const repositories = {};

const find = function(project) {
    let r = repositories[project.id];
    if(!r) {
        r = new TaskCollectionRepository(project);
        repositories[project.id] = r;
    }
    return r;
};

module.exports = {
    find: find
};



// WEBPACK FOOTER //
// ./communication/domain/repository/task-collection.js